import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import tr from './locales/tr.json';
import en from './locales/en.json';
import de from './locales/de.json';

export const SUPPORTED_LANGUAGES = ['tr', 'en', 'de'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const resources = {
  tr: { common: tr },
  en: { common: en },
  de: { common: de },
} as const;

let initialized = false;

/** Initialise i18next once. Idempotent. */
export function initI18n(defaultLng: SupportedLanguage = 'tr'): typeof i18n {
  if (initialized) return i18n;
  initialized = true;
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      lng: defaultLng,
      fallbackLng: defaultLng,
      supportedLngs: [...SUPPORTED_LANGUAGES],
      defaultNS: 'common',
      ns: ['common'],
      interpolation: { escapeValue: false },
      detection: {
        // Persist explicit user choice only. When `eon.lang` is unset, `lng` above applies (tr).
        order: ['localStorage'],
        caches: ['localStorage'],
        lookupLocalStorage: 'eon.lang',
      },
    });
  return i18n;
}

export { i18n };
export { useTranslation, Trans } from 'react-i18next';
export {
  resolveApiError,
  isApiError,
  type ApiErrorLike,
  type TranslateFn,
} from './resolveApiError';
export {
  toStatusKey,
  translateDeviceStatus,
  translateConnectorStatus,
  translateSessionStatus,
  translateInvitationStatus,
  translateStationType,
  translateStationMetaStatus,
  connectorStatusVariant,
  sessionStatusVariant,
  formatConnectorLabel,
  toMeasurandKey,
  translateMeasurand,
} from './statusLabels';
